<template lang="pug">
  include ../../../pug/mixins/bem
  +b.poll-input
    //- +e.item
    +e.item
      slot(
        name='customInput',
        :error='errors.has(name)'
      )              
        +e.INPUT.input(v-bind="$props", 
                      :autofocus='autofocus'
                      :value.prop="value"
                      :class='{"poll-input__input--error": errors.has(name)}'
                      @input="$emit('input',$event.target.value)",
                      @keydown="$emit('keydown',$event.target.value)",
                      @keyup="$emit('keyup',$event.target.value)",
                      )
      +e.LABEL.label(:for='id', :class="{'is-active-label': value }") {{ label }} 
      +e.SPAN.error(v-show="errors.has(name)" ) {{ errors.first(name) }}

</template>
<script>

export default {
  name: "InputGroup",
  inject: ['$validator'],
  props: {
    autofocus: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
      default: 'poll-input'
    },
    type: {
      type: String,
      default: 'text'
    },
    id: String,
    name: String,
    label: String,
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    value: [String, Number, Object],
    'v-validate': String,
    custom: false
  },
  watch: {
    
  }
}
</script>




// WEBPACK FOOTER //
// src/js/shared/components/CustomInputGroup.vue